// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-701ac82d] {\n  display: flex;\n}\n.modal .modal-backdrop[data-v-701ac82d] {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
